import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdLabel } from '@commander-services/gui-components';
import DetailModal, { IDetailModalButton } from '../../DetailModal';
import { ISimpleSelectOption } from '../../Forms/ArrayFields/interfaces';
import { getById, getCustomers } from './OperatingCostTypeService';

interface IOperatingCostTypeDetailProps {
  closeCallback: () => void;
  id: number;
  customerId?: number | null | undefined;
}

function OperatingCostTypeDetail(props: IOperatingCostTypeDetailProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [data, setData] = React.useState<any>(null);
  const [customers, setCustomers] = React.useState<any>(null);
  const [, setIsLoading] = React.useState<boolean>(true);

  const getCustomersData = async () => {
    setIsLoading(true);
    const customersData = await getCustomers();
    if (customersData) {
      setCustomers(customersData);
      setIsLoading(false);
    }
  };

  const getData = async () => {
    if (props.id) {
      setIsLoading(true);
      const operatingCostType = await getById(props.id, props.customerId);
      if (operatingCostType) {
        setData(operatingCostType);
        setIsLoading(false);
      }
    }
  };

  React.useEffect(() => {
    getCustomersData();
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttons: IDetailModalButton[] = [
    {
      id: 'operating-cost-type-close',
      type: 'button',
      className: 'e-button',
      title: f({ id: 'operatingCostTypeForm.close' }),
      closeCallback: props.closeCallback,
    },
  ];

  const getCustomerNameById = (customerId: number, options: ISimpleSelectOption[]): string => {
    if (options) {
      const customer = options.find(
        (option: ISimpleSelectOption) => Number(option.value) === customerId
      );
      if (customer) {
        return customer.item;
      }
    }

    return '';
  };

  return (
    <DetailModal
      id="operating-cost-type-detail"
      title={f({ id: 'table.detail' })}
      buttons={buttons}
    >
      {data && (
        <>
          {props.customerId && (
            <CmdLabel
              id="operating-cost-type-customer"
              title={f({ id: 'operatingCostTypeForm.customer' })}
              value={getCustomerNameById(props.customerId, customers)}
              areLabels={true}
            />
          )}
          <CmdLabel
            id="operating-cost-type-name"
            title={f({ id: 'operatingCostTypeForm.name' })}
            value={data.name}
            areLabels={true}
          />
          <CmdLabel
            id="operating-cost-type-switch"
            title={f({ id: 'operatingCostTypeForm.active' })}
            value={
              data.active
                ? f({ id: 'operatingCostTypeForm.active.yes' })
                : f({ id: 'operatingCostTypeForm.active.no' })
            }
            areLabels={true}
          />
        </>
      )}
    </DetailModal>
  );
}

export default OperatingCostTypeDetail;
